import clsx from "clsx";

export type ButtonSize = "big" | "medium";

export function buttonClassName(
  className: string | undefined,
  darkBackground: boolean,
  disabled: boolean,
  size: ButtonSize,
): string {
  return clsx(
    "font-bold-antialiased bg-primary cursor-pointer rounded-sm text-center uppercase text-white",
    "focus:outline-primary focus:outline-offset-4",
    "hover:bg-primary-hover",
    {
      "border border-white": darkBackground,
      "disabled:bg-gray disabled:cursor-not-allowed": disabled,
      "max-w-md px-3 py-2 text-sm": size === "medium",
      "text-md max-w-full px-6 py-3": size === "big",
    },
    className,
  );
}
